<template>
  <div class="d-flex flex-column w-100">
    <header-row
      :view.sync="view"
      :sample-ids="sampleIds"
      :asset-module-id="assetModuleId"
    />
    <component
      :is="viewComponent"
      :sample-ids="sampleIds"
      :asset-module-id="assetModuleId"
    />
  </div>
</template>

<script>
import HeaderRow from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/Header';
import ChartsView from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/chartsView/index';
import TableView from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/TableView';
import views from '@/domain/data/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/views';

const components = {
  [views.TABLE]: TableView,
  [views.CHARTS]: ChartsView,
};

export default {
  props: {
    sampleIds: {
      type: Array,
    },
  },
  components: {
    HeaderRow,
  },
  data: () => ({
    view: views.TABLE,
  }),
  computed: {
    assetModuleId() {
      return this.$route.params.assetModuleId;
    },
    viewComponent() {
      return components[this.view];
    },
  },
};
</script>
